import React, { useEffect, useState } from "react";
import background from "./images/background.png";
import Accordion from "./atoms/Accordion";
import DownloadAppSection from "./trending/voting/DownloadAppSection";
import StepByStepGuide from "./trending/voting/StepByStepGuide";
import FaqSection from "./trending/voting/FaqSection";
import NoEmailSection from "./trending/voting/NoEmailSection";
import AboutHeatSection from "./trending/voting/AboutHeatSection";

const isActive = (item) => {
  const now = new Date();
  return now >= new Date(item.startTime) && now <= new Date(item.endTime);
};

const VotingGuide = () => {
  const [campaign, setCampaign] = useState(undefined);

  useEffect(() => {
    fetch("/data/trending.json")
      .then((res) => res.json())
      .then((data) => {
        const vote = data.filter(isActive).find((t) => t.type === "vote");
        setCampaign(vote || null);
      })
      .catch(() => setCampaign(null));
  }, []);

  return (
    <div
      className="min-h-full px-6 pt-10 pb-16 font-quicksand"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-2xl mx-auto space-y-8">
        <div className="text-center space-y-2 px-4">
          <div className="text-4xl">🗳️✨</div>
          <h1 className="text-xl font-extrabold text-brand-primary">
            ¿Primera vez votando? Esta guía es para ti.
          </h1>
          <p className="text-sm text-gray-500">
            Aquí tienes todo lo que necesitas para votar por Kari, paso a paso.
          </p>
        </div>

        {campaign && (
          <div className="space-y-3">
            {campaign.appLinks && (
              <Accordion icon="📱" title="Descargar la app" defaultOpen>
                <DownloadAppSection appLinks={campaign.appLinks} />
              </Accordion>
            )}

            <Accordion icon="📖" title="Guía paso a paso" defaultOpen>
              <StepByStepGuide
                categories={campaign.categories}
                steps={campaign.steps}
              />
            </Accordion>

            <Accordion icon="❓" title="Preguntas frecuentes">
              <FaqSection faq={campaign.faq} endTime={campaign.endTime} />
            </Accordion>

            {campaign.appLinks && (
              <Accordion icon="📧" title="¿No tienes un correo?">
                <NoEmailSection />
              </Accordion>
            )}

            <Accordion
              icon="🏆"
              title={campaign.aboutTitle || "Sobre los HEAT"}
            >
              <AboutHeatSection ceremony={campaign.ceremony} />
            </Accordion>
          </div>
        )}

        {campaign === null && (
          <p className="text-center italic text-brand-muted">
            No hay ninguna votación activa en este momento.
          </p>
        )}

        <div className="text-center space-y-1">
          <p className="text-sm font-semibold text-brand-primary">
            🚀 ¡Ya sabes cómo votar!
          </p>
          <a
            href="/tendencia"
            className="text-sm font-semibold underline text-brand-primary"
          >
            Regresar a la votación
          </a>
        </div>
      </div>
    </div>
  );
};

export default VotingGuide;
